import React from 'react';
import { Box, Typography, Container, Grid, Avatar, Paper } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import founderImg from "src/assets/img/founder.jpeg"

import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import StarIcon from '@mui/icons-material/Star';
import VerifiedUserIcon from '@mui/icons-material/Verified';
const teamMembers = [
  'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=500&q=80',
  'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=500&q=80',
  'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=500&q=80',
  'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=500&q=80',
  'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=500&q=80',
  'https://images.unsplash.com/photo-1544725176-7c40e5a2c9f9?auto=format&fit=crop&w=500&q=80',
  'https://images.unsplash.com/photo-1527980965255-d3b416303d12?auto=format&fit=crop&w=500&q=80',
  'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=500&q=80'
];

const AboutSection: React.FC = () => {
  return (
    <Box id="about" sx={{ backgroundColor: '#ffffff', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={8} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="overline" sx={{ color: '#1f5d3b', fontWeight: 600, letterSpacing: 2, mb: 1, display: 'block' }}>
              WHO WE ARE
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 3, color: '#111' }}>
              Hisham Abdullah Al-Sheikh & Partners Law Firm and Legal Consultants
            </Typography>

            <Typography sx={{ fontSize: '1.1rem', color: '#555', lineHeight: 1.8, mb: 3 }}>
              Hisham Bin Abdullah Al-Sheikh &amp; Partners Law Firm represents a pioneering legal vision led by its founder, lawyer Hisham Bin Abdullah Al-Sheikh.            </Typography>

            <Typography sx={{ fontSize: '1.1rem', color: '#555', lineHeight: 1.8 }}>
              With a strong academic background in Sharia and law in general, and postgraduate studies in intellectual property, he started as an assistant in the Mana Tigori Court in Ohio until he became a distinguished lawyer and consultant to various public and private entities.
            </Typography>

            <Grid container spacing={4} sx={{ mt: 2 }}>
              <Grid item xs={12} sm={6}>
                <Paper elevation={0} sx={{ p: 3, backgroundColor: '#f9fafb', borderRadius: '16px', border: '1px solid #eee' }}>
                  <Box sx={{ color: '#1f5d3b', mb: 2 }}><StarIcon fontSize="large" /></Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Our Mission</Typography>
                  <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.6 }}>
                    Outstanding legal representation to achieve the desired results, along with a commitment to spreading legal culture widely.
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper elevation={0} sx={{ p: 3, backgroundColor: '#f9fafb', borderRadius: '16px', border: '1px solid #eee' }}>
                  <Box sx={{ color: '#1f5d3b', mb: 2 }}><VerifiedUserIcon fontSize="large" /></Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Our vision</Typography>
                  <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.6 }}>
                    To be a leading law firm both locally and globally, exceeding our clients’ expectations as a trusted strategic partner.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ position: 'relative' }}>
              <Box
                component="img"
                src={founderImg}
                sx={{
                  width: '100%',
                  borderRadius: '24px',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                  position: 'relative',
                  zIndex: 2
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: -30,
                  left: -30,
                  width: '200px',
                  height: '200px',
                  backgroundColor: 'rgba(31, 93, 59, 0.1)',
                  borderRadius: '24px',
                  zIndex: 1
                }}
              />
            </Box>
          </Grid>
        </Grid>

        {/* <Box sx={{ mt: { xs: 12, md: 16 } }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="overline" sx={{ color: '#1f5d3b', fontWeight: 600, letterSpacing: 2, mb: 1, display: 'block' }}>
              OUR EXPERTS
            </Typography>
            <Typography variant="h3" sx={{ fontWeight: 700, color: '#111' }}>
              Meet the Legal Team
            </Typography>
          </Box>

          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            style={{ paddingBottom: "60px" }}
            breakpoints={{
              0: { slidesPerView: 1 },
              600: { slidesPerView: 2 },
              900: { slidesPerView: 3 },
              1200: { slidesPerView: 4 }
            }}
          >
            {teamMembers.map((member, index) => (
              <SwiperSlide key={index}>
                <Box display="flex" justifyContent="center">
                  <Avatar
                    src={member}
                    sx={{
                      width: 260,
                      height: 260,
                      boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
                      border: '6px solid #fff',
                      transition: 'transform 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.05)'
                      }
                    }}
                  />
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>  */}
      </Container>
    </Box>
  );
};

export default AboutSection;

